import {makeAutoObservable} from 'mobx';

import {Balance, defaultBalance} from '@/domain';
import {ONE_HOUR_MS} from '@/shared/consts/time';

class BalanceStore {
  private instance = {...defaultBalance};

  constructor() {
    makeAutoObservable(this);
  }

  get balance() {
    return this.instance;
  }

  setBalance(balance: Balance) {
    this.instance = balance;
  }

  get hasSuperSmashes() {
    return this.balance.super_smashes > 0;
  }

  get hasSmashes() {
    return this.balance.smashes > 0;
  }

  get hasBoosts() {
    return this.balance.boosts > 0;
  }

  addBoosts(boosts: number) {
    this.balance.boosts += boosts;
  }

  addSuperSmashes(superSmashes: number) {
    this.balance.super_smashes += superSmashes;
  }

  clearSmashesAndUpdateNextBonusAccrual() {
    this.balance.smashes = 0;
    this.balance.free_smashes_bonus_next_at = 12 * ONE_HOUR_MS + Date.now();
  }

  utilizeBoost() {
    if (this.balance.boosts <= 0) {
      return;
    }

    this.balance.boosts -= 1;
  }

  utilizeSmash() {
    if (this.balance.smashes <= 0) {
      return;
    }

    this.balance.smashes -= 1;
  }

  utilizeSuperSmash() {
    if (this.balance.super_smashes <= 0) {
      return;
    }

    this.balance.super_smashes -= 1;
  }

  setZeroSuperSmashes() {
    this.balance.super_smashes = 0;
  }
}

export const balanceStore = new BalanceStore();
